import { routes } from 'appConstants';

export type MediaTabId =
  | 'all'
  | 'news'
  | 'faces'
  | 'gallery'
  | 'articles'
  | 'spec'
  | 'tours'
  | 'lifehacks'
  | 'buy'
  | 'experts';

export const MEDIA_TABS: Array<{ id: MediaTabId, label: string, to: string }> = [
  { id: 'all', label: 'Все новости', to: routes.media.news.root },
  { id: 'news', label: 'Новости', to: `${routes.media.news.root}?filter=news` },
  { id: 'faces', label: 'Истории успеха', to: `${routes.media.videoFaces.root}/2` },
  { id: 'gallery', label: 'Галерея', to: routes.media.gallery.root },
  { id: 'articles', label: 'Статьи', to: routes.media.articles.root },
  { id: 'spec', label: 'Внешние мероприятия', to: routes.media.specProjects.root },
  { id: 'tours', label: 'Технотуры', to: routes.media.techTours.root },
  { id: 'lifehacks', label: 'Лайфхаки', to: `${routes.media.videoLifeHacks.root}/5` },
  { id: 'buy', label: 'BUY IN MOSCOW', to: `${routes.media.videoWhatBuy.root}/4` },
  { id: 'experts', label: 'Эксперты об экспорте', to: `${routes.media.videoAboutExport.root}/3` },
];

export const isMediaTabActive = (
  tabId: MediaTabId,
  pathname: string,
  search = '',
): boolean => {
  const params = new URLSearchParams(search);
  const newsFilter = params.get('filter');

  switch (tabId) {
    case 'all':
      return pathname === routes.media.news.root && newsFilter !== 'news';
    case 'news':
      return pathname === routes.media.news.root && newsFilter === 'news';
    case 'faces':
      return pathname.startsWith(routes.media.videoFaces.root);
    case 'gallery':
      return pathname.startsWith(routes.media.gallery.root);
    case 'articles':
      return pathname.startsWith(routes.media.articles.root);
    case 'spec':
      return pathname.startsWith(routes.media.specProjects.root);
    case 'tours':
      return pathname.startsWith(routes.media.techTours.root);
    case 'lifehacks':
      return pathname.startsWith(routes.media.videoLifeHacks.root);
    case 'buy':
      return pathname.startsWith(routes.media.videoWhatBuy.root);
    case 'experts':
      return pathname.startsWith(routes.media.videoAboutExport.root);
    default:
      return false;
  }
};
